import { DateFormats, formatDate } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { IssueDetail } from '@strata/react-status-icons';
import PropTypes from 'prop-types';

import { LabelWithIssue } from 'components/opportunities/LabelWithIssue';

export const OpportunityDetails = ({ opportunityDetails = undefined }) => (
    <FormSectionWithRows
        sectionTitle="Opportunity Details"
        isLoading={!opportunityDetails?.referralId}
        width="100%"
        rowOneContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="Received Date"
                    value={formatDate(opportunityDetails?.receivedTime, DateFormats.DATE_TIME)}
                />
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="Product Type"
                    value={opportunityDetails?.isBrand ? 'Brand' : 'Generic'}
                />
                <DetailLabelValuePair
                    style={{ width: '34%' }}
                    label={
                        <LabelWithIssue
                            text="Place of Service"
                            issues={opportunityDetails?.issues}
                            issueType={IssueDetail.IssueTypes.MISSING_PLACE_OF_SERVICE}
                        />
                    }
                    value={opportunityDetails?.placeOfService}
                />
            </>
        }
        rowTwoContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label="NDC"
                    value={opportunityDetails?.productServiceId}
                />
                <DetailLabelValuePair
                    style={{ width: '33%' }}
                    label={
                        <LabelWithIssue
                            text="Qty"
                            issues={opportunityDetails?.issues}
                            issueType={IssueDetail.IssueTypes.INVALID_PRODUCT_QUANTITY}
                        />
                    }
                    value={opportunityDetails?.productQty}
                />
            </>
        }
    />
);

OpportunityDetails.propTypes = {
    opportunityDetails: PropTypes.shape({
        receivedTime: PropTypes.string,
        referralExpiration: PropTypes.string,
        placeOfService: PropTypes.string,
        referralId: PropTypes.string,
        productServiceId: PropTypes.string,
        productQty: PropTypes.number,
        isBrand: PropTypes.bool,
        issues: PropTypes.arrayOf(PropTypes.string),
    }),
};
